export default () => {

  const cross = document.querySelectorAll(".cross");

  function parallax(e) {
    if (document.documentElement.clientWidth >= 1024) {
      for (let i = 0; i < cross.length; i++) {
        const speed = cross[i].getAttribute("data-speed");
        cross[i].style.transform = "translate3d(" + -parseInt(e.clientX * speed / 1000) + "px, " + -parseInt(e.clientY * speed / 1000) + "px, 0)"
      }
    }
  }

  document.addEventListener("mousemove", parallax);
};
